/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const ArrowBack = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 6 10" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M5.19 10a.8.8 0 0 1-.55-.23L.26 5.48A.9.9 0 0 1 0 4.84a.92.92 0 0 1 .28-.63l4.38-4A.77.77 0 0 1 5.8.3a.87.87 0 0 1-.08 1.2L2 4.88l3.74 3.64a.88.88 0 0 1 0 1.21.76.76 0 0 1-.59.27" />
      </g>
    </svg>
  </span>
);

ArrowBack.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

ArrowBack.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default ArrowBack;
